import { render, staticRenderFns } from "./payment1.vue?vue&type=template&id=151bcbd9&scoped=true&"
import script from "./payment1.vue?vue&type=script&lang=js&"
export * from "./payment1.vue?vue&type=script&lang=js&"
import style0 from "./payment1.vue?vue&type=style&index=0&id=151bcbd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151bcbd9",
  null
  
)

export default component.exports